import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledSignatureChefContainer = styled.div`
  .carouselControlType2 .left-arrow,
  .carouselControlType2 .right-arrow {
    height: auto;
  }

  .carouselControlType2 {
    padding-top: ${toRem(48)};

    @media ${baseVariables.mediaQuery.md} {
      padding-top: ${toRem(32)};
    }
  }
`;
